import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const founders = [
  {
    name: "Virginie Haas",
    title: "Consultante",
    bio: "Après une carrière dans la Tech, en France comme à l'international, au sein de start-up et de grands groupes, j'ai choisi de me consacrer pleinement à la transmission. Je poursuis aujourd'hui cet engagement à travers Winstone Consulting, où j'accompagne des dirigeants, et par l'écriture, avec la publication de « La vente commence quand le client dit non » (Eyrolles, 2024).\nLa naissance de ma première petite-fille a profondément renforcé ma réflexion sur la responsabilité que nous portons envers les jeunes générations. Dans un monde où l'individualisme progresse et où chacun tend à évoluer dans son couloir de nage, comment contribuer, à mon échelle, à restaurer la confiance et le vivre-ensemble en France ? M'investir au sein de l'association Enfants de la République s'est imposé comme une évidence : une manière concrète d'agir pour transmettre nos valeurs républicaines et renforcer le lien entre les citoyens de demain."
  },
  {
    name: "Nathalie Adjedj",
    title: "Psychologue Psychanalyste",
    bio: "Après avoir commencé ma carrière dans la publicité, j'ai rejoint le Groupe SNCF, occupant différents postes de direction opérationnelle (Direction de la gare Montparnasse) et stratégiques.\n\nJe me suis ensuite reconvertie, j'ai obtenu un master de psychologie clinique, travaillé dans plusieurs centres en hôpital et ouvert un cabinet de psychologue / psychanalyste en libéral à Paris.\n\nLa prise en compte des ressorts humains ou de ce qui peut diviser ou faire socle dans une société sont pour moi des sujets fondamentaux au cœur des objectifs de l'association Enfants de la République, pour laquelle il m'est ainsi indispensable de m'engager."
  },
  {
    name: "Thierry Keller",
    title: "Journaliste, Essayiste",
    bio: "Ancien membre du Bureau national de SOS Racisme, j'ai longtemps dirigé la rédaction du trimestriel de prospective Usbek & Rica. Aujourd'hui, Conférencier et consultant, je dirige la collection « Ça va bien se passer » aux éditions de l'Aube. Je suis l'auteur de plusieurs essais, dont « Ce qui nous rassemble » (2017), « Entre déclin et grandeur » (avec Arnaud Zegierman, 2021) et « Quand on n'ose plus rien dire, de peur de passer pour un réac » (2024). Je collabore à l'hebdomadaire Franc-Tireur. Mon parcours me conduit naturellement à m'engager avec Enfants de la République pour la transmission des valeurs universelles du vivre ensemble."
  },
  {
    name: "Frédéric Sebag",
    title: "Chef d'entreprise",
    bio: "Fondateur (1989) et Président du Groupe Open, une des premières entreprises de Service du Numérique Françaises.\n\nA la pointe des technologies numériques, cotée en bourse durant 24 ans, Open reste toujours soucieuse de ses 4 000 collaborateurs, de ses clients et de ses valeurs.\n\nAdministrateur de Numeum, je participe au développement de ce syndicat professionnel depuis près de 10 ans.\n\nJe consacre une part de mon temps à l'association Enfants de la République pour transmettre et valoriser les principes formidables de notre société."
  },
  {
    name: "Gérard Pazuelo",
    title: "Directeur Cybersécurité",
    bio: "Dans le monde IT et cyber depuis plus de 38 ans, j'ai d'abord travaillé sur les technologies de l'information pour de grandes organisations et ensuite développé mes propres activités en tant qu'entrepreneur dans le secteur de la Télévision Numérique puis de la Cybersécurité.\n\nPassionné de sport et amateur de l'étude relative à la question de la liberté, j'ai décidé de faire partie des fondateurs de Enfants de la République pour passer à l'action et défendre les valeurs de notre modèle républicain."
  }
];

export default function Association() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-[#FFFD4C] via-[#FFFD4C] to-[#F5E84A]">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 pt-28">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-[#1E3A8A]">
            L'Association
          </h1>
          <p className="text-sm md:text-[15px] text-[#1E3A8A] mb-6 font-medium">
            La bio des fondateurs
          </p>
          
          <div className="space-y-4">
            {founders.map((founder, index) => (
              <Card key={index} className="bg-gray-200/80 backdrop-blur-sm border border-black/10 shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden">
                <CardHeader className="relative p-4 md:p-5 pb-2">
                  <div className="absolute top-0 right-0 w-24 h-24 opacity-30">
                    <img 
                      src="/lovable-uploads/4e099779-9f93-42cf-8071-5264f3cec1da.png" 
                      alt="" 
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <CardTitle className="text-lg md:text-xl font-bold text-[#1E3A8A] relative z-10 flex items-center gap-2">
                    {founder.name}
                    <img 
                      src="/lovable-uploads/marianne-logo.png" 
                      alt="Marianne" 
                      className="w-5 h-5 object-contain inline-block"
                    />
                  </CardTitle>
                  <p className="text-sm md:text-[15px] font-medium text-[#1E3A8A] relative z-10">
                    {founder.title}
                  </p>
                </CardHeader>
                <CardContent className="p-4 md:p-5 pt-0">
                  <p className="text-sm md:text-[15px] text-[#1E3A8A] whitespace-pre-line leading-snug">
                    {founder.bio}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
